import { useTranslation } from '@mint-lib/i18n';
import { ProgressLinear } from '@mint-lib/tw-components/patterns';

import EmptyMessage from '../../atoms/EmptyMessage/EmptyMessage.jsx';

type Props = {
  isTabEmpty: boolean;
  isProgress: boolean;
};

const SuggestionEntityEmpty = ({ isTabEmpty, isProgress }: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');
  if (isProgress) {
    return (
      <div className="flex h-full flex-row items-center justify-center">
        <ProgressLinear className="w-[33%]" determinate={false} />
      </div>
    );
  }
  if (isTabEmpty) {
    return (
      <div className="flex h-full flex-row items-center justify-center">
        <EmptyMessage
          message={t("You don't have any suggestion for this tab")}
        />
      </div>
    );
  }
  return (
    <div className="flex h-full flex-row items-center justify-center">
      <EmptyMessage message={t('To visualise some suggestions click a card')} />
    </div>
  );
};

export default SuggestionEntityEmpty;
